import { render, staticRenderFns } from "./new_teacher.vue?vue&type=template&id=001f8fef&scoped=true"
import script from "./new_teacher.vue?vue&type=script&lang=ts"
export * from "./new_teacher.vue?vue&type=script&lang=ts"
import style0 from "./new_teacher.vue?vue&type=style&index=0&id=001f8fef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001f8fef",
  null
  
)

export default component.exports